(function () {
  function initEubleMusicPlayer() {
    var root = document.querySelector('[data-euble-music-player]');
    if (!root || root.getAttribute('data-euble-music-ready') === 'true') return;

    var audio = root.querySelector('[data-euble-music-audio]');
    var toggle = root.querySelector('[data-euble-music-toggle]');
    var label = root.querySelector('[data-euble-music-label]');
    if (!audio || !toggle) return;

    root.setAttribute('data-euble-music-ready', 'true');

    var volume = parseFloat(root.getAttribute('data-volume') || '0.5');
    if (isNaN(volume)) volume = 0.5;
    audio.volume = Math.max(0, Math.min(1, volume));

    function setPlaying(isPlaying) {
      root.classList.toggle('is-playing', isPlaying);
      toggle.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      toggle.setAttribute('aria-label', isPlaying ? 'Mettre la musique en pause' : 'Lancer la musique');
      if (label) label.textContent = isPlaying ? 'Pause' : 'Lire';
    }

    function tryPlay() {
      var promise = audio.play();
      if (promise && typeof promise.then === 'function') {
        promise.then(function () {
          setPlaying(true);
        }).catch(function () {
          setPlaying(false);
        });
      } else {
        setPlaying(true);
      }
    }

    function playAfterFirstInteraction() {
      if (!audio.paused) return;
      tryPlay();
    }

    function bindAutoplayTriggers() {
      var events = ['pointerdown', 'pointermove', 'mousemove', 'touchstart', 'click', 'keydown'];
      events.forEach(function (eventName) {
        document.addEventListener(eventName, playAfterFirstInteraction, { once: true, passive: true });
      });
      window.addEventListener('scroll', playAfterFirstInteraction, { once: true, passive: true });
    }

    toggle.addEventListener('click', function () {
      if (audio.paused) {
        tryPlay();
      } else {
        audio.pause();
        setPlaying(false);
      }
    });

    audio.addEventListener('play', function () { setPlaying(true); });
    audio.addEventListener('pause', function () { setPlaying(false); });
    audio.addEventListener('ended', function () { setPlaying(false); });

    if (root.getAttribute('data-autoplay') === 'true') {
      tryPlay();
      bindAutoplayTriggers();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEubleMusicPlayer);
  } else {
    initEubleMusicPlayer();
  }
})();

